import {
  ADD_EXTRA_SECTION_ACTION,
  APPLY_CHANGE_TITLE_ACTION,
  APPLY_CHANGE_TITLE_KEY,
  REFRESH_SECTIONS_DATA_SOURCE_ACTION,
  RESET_DATA_NOTES_ACTION,
  RESET_DATA_NOTES_KEY,
  SECTION_REFRESH_DATA_SOURCE_KEY,
  UPDATE_DATA_NOTES_ACTION,
  UPDATE_DATA_NOTES_KEY,
} from 'src/redux/constants';
import type { ViewAction, ViewActionPayload } from 'src/redux/viewState/types';
import type {
  ReceiveDataNotesPayload,
  ReceiveDataNotesResponseAction,
} from './types';

export const RECEIVE_DATA_NOTES_FROM_API = 'RECEIVE_DATA_NOTES_FROM_API';

export const selectSectionsDataSource = (
  sectionId: ViewActionPayload,
): ViewAction => {
  return {
    type: REFRESH_SECTIONS_DATA_SOURCE_ACTION,
    dataKey: SECTION_REFRESH_DATA_SOURCE_KEY,
    value: sectionId,
  };
};

export const UpdateDataNotes = (
  data: ViewActionPayload,
  sectionPk: ViewActionPayload,
): ViewAction => {
  return {
    type: UPDATE_DATA_NOTES_ACTION,
    dataKey: UPDATE_DATA_NOTES_KEY,
    value: { value: data, sectionPk: sectionPk },
  };
};

export const ResetDataNotesMessage = (): ViewAction => {
  return {
    type: RESET_DATA_NOTES_ACTION,
    dataKey: RESET_DATA_NOTES_KEY,
  };
};

export const ApplyChangeTitle = (
  title: ViewActionPayload,
  sectionPk: ViewActionPayload,
): ViewAction => {
  return {
    type: APPLY_CHANGE_TITLE_ACTION,
    dataKey: APPLY_CHANGE_TITLE_KEY,
    value: { title: title, sectionPk: sectionPk },
  };
};

export const addExtraSection = (report_id: ViewActionPayload): ViewAction => {
  return {
    type: ADD_EXTRA_SECTION_ACTION,
    dataKey: 'addExtraSectionToReport',
    value: report_id,
  };
};

export const receiveDataNotesResponse = (
  dataKey: string,
  json: ReceiveDataNotesPayload,
  request_params?: Record<string, unknown>,
): ReceiveDataNotesResponseAction => {
  return {
    type: RECEIVE_DATA_NOTES_FROM_API,
    dataKey,
    payload: json,
    request_params,
  };
};
